import { ReactNode } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { primarySoft } from '../../../../../../theme';
import { CashdeskBlock } from './cashdeskBlocks';

interface BlockActionsProps {
  block: CashdeskBlock;
  onUpdate: (patch: Partial<CashdeskBlock>) => void;
  onRemove: () => void;
}

function BlockActions({ block, onUpdate, onRemove }: BlockActionsProps) {
  const iconSx = (color: string) => ({ fontSize: '0.85rem', color });

  const actions: Array<{ title: string; icon: ReactNode; onClick: () => void }> = [
    { title: 'Rotation 90°', icon: <RotateRightIcon sx={iconSx('primary.main')} />, onClick: () => onUpdate({ rotation: (block.rotation + 90) % 360 }) },
    { title: 'Avancer', icon: <ArrowUpwardIcon sx={iconSx('text.primary')} />, onClick: () => onUpdate({ zIndex: block.zIndex + 1 }) },
    { title: 'Reculer', icon: <ArrowDownwardIcon sx={iconSx('text.primary')} />, onClick: () => onUpdate({ zIndex: Math.max(0, block.zIndex - 1) }) },
    { title: 'Supprimer', icon: <DeleteOutlineIcon sx={iconSx('error.main')} />, onClick: onRemove },
  ];

  return (
    <Box
      sx={{ position: 'absolute', top: -22, left: 0, display: 'flex', gap: 0.25, backgroundColor: 'background.paper', border: '1px solid', borderColor: theme => primarySoft(theme, 0.25), borderRadius: 1, px: 0.5, py: 0.25 }}
      onPointerDown={e => e.stopPropagation()}
    >
      {actions.map(action => (
        <Tooltip key={action.title} title={action.title}>
          <IconButton size="small" onClick={action.onClick} sx={{ p: 0.25 }}>
            {action.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
}

export default BlockActions;
